module.exports = __webpack_public_path__ + "img/impressions.bd009656.svg";